import { useContext } from 'react'
import { ScheduledPlayerContext } from '@contexts/index'

export const useScheduledPlayerContext = () => useContext(ScheduledPlayerContext)
